<template>
  <label
    class="btn form-check-label waves-effect waves-light mr-3 mb-3"
    :class="[
      buttonClass,
      {
        'recommend-btn': buttonType == 'round',
        'active': clicked,
        'text-wrap': isWrap
      }
    ]"
    :for="buttonId"
    @click="selectEvent"
  >
    <div
      v-if="buttonType == 'round'"
      class="content"
    >
      <input
        type="radio"
        :name="postName"
        class="form-check-input"
        :value="buttonValue"
        :checked="clicked"
      >
      {{ buttonLabel }}
    </div>
    <div v-else>
      <input
        type="radio"
        :name="postName"
        class="form-check-input"
        :value="buttonValue"
        :checked="clicked"
      >
      {{ buttonLabel }}
    </div>
  </label>
</template>

<script>
export default {
  props: {
    buttonClass: {
      type: String,
      default: "text-left"
    },
    buttonId: {
      type: String,
      required: true
    },
    buttonLabel: {
      type: String,
      required: true
    },
    postName: {
      type: String,
      default: "single_selected"
    },
    clicked: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    buttonValue: {
      type: String,
      required: true
    },
    isWrap: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      buttonType: ""
    };
  },
  mounted() {
    if (isNaN(Number(this.buttonLabel))) {
      this.buttonType = "tile";
    } else {
      this.buttonType = "round";
    }
  },
  methods: {
    selectEvent() {
      this.$emit("select");
    }
  }
};
</script>

<style scoped lang="scss">
label {
  &.btn {
    font-weight: 500;
    width: auto !important;
    white-space: nowrap;
  }
  &.recommend-btn {
    position: relative;
    padding: 19px;
    box-shadow: none;
  }
  &.recommend-btn:before {
    display: block;
    content: "";
    padding-top: 100%;
  }
}
.content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  box-sizing: border-box;
}
</style>
